import { atom } from "jotai";

export const isAddingNewGuestAtom = atom<boolean>(false);
